export const GET_FORNECEDOR_DATA = "GET_FORNECEDOR_DATA";
export const FORNECEDOR_LOAD = "FORNECEDOR_LOAD";
export const FORNECEDOR_LOAD_ALL = "FORNECEDOR_LOAD_ALL";
export const FORNECEDOR_ALL = "FORNECEDOR_ALL";
export const FORNECEDOR_UPDATE = "FORNECEDOR_UPDATE";
